/**
 * 更新app top bar内容
 * @param object
 */
export function updateTopBar(title, styleId) {
    if (typeof window !== 'undefined' && window.G) {
        document.title = title;
        if (window.G.isApp && window.G.webviewBridgeReady) {
            window.G.webviewBridgeReady(function(bridge) {
                bridge.callHandler('setAppHeader', {
                    'mainTitle': title,
                    "styleId": styleId,
                }, function (json) {});
            });
        }
    }
}

/**
*  记录cookie补充统计中fu
*/
export function setFromUrl() {
    if (typeof document !== 'undefined') {
        document.cookie = 'from_url=' + location.href + ';path=/;domain=.tuniu.com';
    }
}



// WEBPACK FOOTER //
// libs/business/tkd.js